/* eslint-disable */
export default {
  region: '地域',
  calling: '発信',
  logout: 'ログアウト',
  version: 'バージョン',
  settings: '設定',
  selectToDialSMS: 'ダイヤル/SMSを選択',
  selectToDial: 'ダイヤルを選択',
  selectToSMS: 'SMSを選択',
  clickToDial: 'クリックダイヤル',
  autoCreateLog: '通話ログの自動作成',
  autoCreateSMSLog: 'SMSログの自動作成',
  autoLogCalls: '通話の自動記録',
  autoLogNotes: 'メモを自動記録',
  autoLogSMS: 'SMSを自動記録',
  clickToSMS: 'クリックSMS',
  logSMSContent: 'SMSコンテンツの記録',
  clickToDialSMS: 'クリックダイヤル/SMS',
  logExtensionCall: '内線通話を記録',
  audio: '音声',
  language: '言語',
  feedback: 'フィードバック',
  userGuide: '新着情報',
  quickAccess: 'クイックアクセスの設定',
  report: '分析レポート',
  shareIdea: 'アイデアを共有',
  openEntityFrom: 'Salesforceオブジェクトの動作',
  ctiPanelSize: 'CTIパネルサイズ',
  openInNewTab: '新しいタブで開く',
  openInCurrentTab: '現在のタブで開く',
  reportIssue: '問題を報告',
  contactSupport: 'サポートへのお問い合わせ',
  selectToDialHint:
    'エクスペリエンス向上のため、大量の電話番号が記載されているページからRingCentralでダイヤルする電話番号を選択してください。',
} as const;

// @key: @#@"region"@#@ @source: @#@"Region"@#@
// @key: @#@"calling"@#@ @source: @#@"Calling"@#@
// @key: @#@"logout"@#@ @source: @#@"Logout"@#@
// @key: @#@"version"@#@ @source: @#@"Version"@#@
// @key: @#@"settings"@#@ @source: @#@"Settings"@#@
// @key: @#@"selectToDialSMS"@#@ @source: @#@"Select to Dial/SMS"@#@
// @key: @#@"selectToDial"@#@ @source: @#@"Select to Dial"@#@
// @key: @#@"selectToSMS"@#@ @source: @#@"Select to SMS"@#@
// @key: @#@"clickToDial"@#@ @source: @#@"Click to Dial"@#@
// @key: @#@"autoCreateLog"@#@ @source: @#@"Auto-create Call Log"@#@
// @key: @#@"autoCreateSMSLog"@#@ @source: @#@"Auto-create SMS Log"@#@
// @key: @#@"autoLogCalls"@#@ @source: @#@"Auto log calls"@#@
// @key: @#@"autoLogNotes"@#@ @source: @#@"Auto log notes"@#@
// @key: @#@"autoLogSMS"@#@ @source: @#@"Auto log SMS"@#@
// @key: @#@"clickToSMS"@#@ @source: @#@"Click to SMS"@#@
// @key: @#@"logSMSContent"@#@ @source: @#@"Log SMS content"@#@
// @key: @#@"clickToDialSMS"@#@ @source: @#@"Click to Dial/SMS"@#@
// @key: @#@"logExtensionCall"@#@ @source: @#@"Log extension calls"@#@
// @key: @#@"audio"@#@ @source: @#@"Audio"@#@
// @key: @#@"language"@#@ @source: @#@"Language"@#@
// @key: @#@"feedback"@#@ @source: @#@"Feedback"@#@
// @key: @#@"userGuide"@#@ @source: @#@"What's New"@#@
// @key: @#@"quickAccess"@#@ @source: @#@"Quick Access Setting"@#@
// @key: @#@"report"@#@ @source: @#@"Analytics Report"@#@
// @key: @#@"shareIdea"@#@ @source: @#@"Share idea"@#@
// @key: @#@"openEntityFrom"@#@ @source: @#@"Salesforce object behavior"@#@
// @key: @#@"ctiPanelSize"@#@ @source: @#@"CTI panel size"@#@
// @key: @#@"openInNewTab"@#@ @source: @#@"Open in new tab"@#@
// @key: @#@"openInCurrentTab"@#@ @source: @#@"Open in current tab"@#@
// @key: @#@"reportIssue"@#@ @source: @#@"Report issue"@#@
// @key: @#@"contactSupport"@#@ @source: @#@"Contact support"@#@
// @key: @#@"selectToDialHint"@#@ @source: @#@"For your better experience, select phone number to dial with RingCentral in large quantity phone number page."@#@
